import {STATE_ANALYSE, STATE_ANNULER, STATE_PRISE_EN_COMPTE, STATE_TERMINER} from "./constants";
import {BASE} from "../api/Api";

export function get(obj, path, def) {
    var fullPath = path
        .replace(/\[/g, '.')
        .replace(/]/g, '')
        .split('.')
        .filter(Boolean);

    return fullPath.every(everyFunc) ? obj : def;

    function everyFunc(step) {
        return !(step && (obj = obj[step]) === undefined);
    }
}

export function formatNumber(value) {
    if (!value) return value;

    value = value.toString()
    const d = value.replace(/\B(?=(\d{3})+(?!\d))/g, " ")

    return `${d}`
}

export function convertToLocalState(onlineState){
    switch (onlineState){
        case 'App\\Models\\Fiches\\States\\AnnuleStep':
            return STATE_ANNULER;
        case 'App\\Models\\Fiches\\States\\AnalyseStep':
            return STATE_ANALYSE;
        case 'App\\Models\\Fiches\\States\\PriseEnCompteStep':
            return STATE_PRISE_EN_COMPTE;
        case 'App\\Models\\Fiches\\States\\TerminerStep':
            return STATE_TERMINER;
    }
}

export function generateRandomString(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function getFicheLocalStateDate(fiche,localState){

    const localStateHistory = fiche.state_histories.find(
        item => localState === convertToLocalState(item.new_state)
    );

    if(localStateHistory)
        return localStateHistory.created_at;

    return null
}

export function getItemById(array,itemId){
    return array.find(item=>item.id === itemId)
}

export function getFileUrl(fileId){
    return `http://${BASE}/file/view/${fileId}`;
}

export function addHttpPrefix(url){

    if(!url)
        return undefined;

    if(url.startsWith('http://') || url.startsWith('https://'))
        return url;

    return `https://${url}`;
}